/* import __COLOCATED_TEMPLATE__ from './sq-unavailable.hbs'; */
/**
## SqUnavailable

Displays a null-state page.

```example
@title Basic Usage with an icon.
@description This will display the icon provided by the icon class.

@hbs
{{sq-unavailable header=(t "inventory2.index.nullState.header")
                 hint=(t "inventory2.index.nullState.hint")
                 iconClassName="icon-null-state-sales-transactions"}}
```

```example
@title Basic Usage with an SVG.
@description This will display the SVG provided by the svg component name.

@hbs
{{sq-unavailable header=(t 'inventory2.index.nullState.header')
                  hint=(t 'inventory2.index.nullState.hint')
                  svg=Component  (need in JS/TS: import Component from 'url/path/to/svg/component';)
                  svgWidth=122
                  svgHeight=122
                  originalSvgWidth=80
                  originalSvgHeight=80
                  svgClassName="svg-icon--theme-color-medium"}}
```

### Parameters
 * @param {string} [iconClassName] Icon to be displayed.
 * @param {string} [header] Header text.
 * @param {string} [hint] Hint text.
 * @param {string} [svg] An imported SVG component. This will replace the icon.
 * @param {int} [svgWidth] SVG width.
 * @param {int} [svgHeight] SVG height.
 * @param {int} [originalSvgHeight] the original height of the SVG.
 * @param {int} [originalSvgWidth] the original width of the SVG.
 * @param {string} [svgClassName] CSS class for SVG component.
*/

import { bool, notEmpty } from '@ember/object/computed';
import Component from '@ember/component';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  classNames: ['unavailable'],
  iconClassName: 'icon-null-beta',
  shouldShowIcon: bool('iconClassName'),
  shouldShowHint: notEmpty('hint'),
  svgClassName: '',
  shouldShowSvg: bool('svg')
});